import {api} from './api';

export type ApiKeyRecord = {
	id: string;
	name: string;
	keyPrefix: string;
	createdAt: string;
};

export type CreatedApiKeyRecord = ApiKeyRecord & {
	key: string;
};

export const apiKeysApi = api.injectEndpoints({
	endpoints: (builder) => ({
		apiKeysFind: builder.query<ApiKeyRecord[], void>({
			query: () => 'api-keys',
			providesTags: ['ApiKeys'],
		}),
		apiKeyCreate: builder.mutation<CreatedApiKeyRecord, {name: string}>({
			query: (body) => ({
				url: 'api-keys',
				method: 'POST',
				body,
			}),
			invalidatesTags: ['ApiKeys'],
			extraOptions: {maxRetries: 0},
		}),
		apiKeyDelete: builder.mutation<void, {id: string}>({
			query: ({id}) => ({
				url: `api-keys/${id}`,
				method: 'DELETE',
			}),
			invalidatesTags: ['ApiKeys'],
			extraOptions: {maxRetries: 0},
		}),
	}),
});

export const {
	useApiKeysFindQuery,
	useApiKeyCreateMutation,
	useApiKeyDeleteMutation,
} = apiKeysApi;
